import React, { useState } from "react";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import LoadingButton from "@mui/lab/LoadingButton";
import { Container, Button, Autocomplete, TextField } from "@mui/material";

import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { ReactComponent as CrossBtn } from "../../assets/svg/CrossButton.svg";
import { ReactComponent as File } from "../../assets/svg/File.svg";

import { useNavigate } from "react-router-dom";

import "./styles.css";
import styled from "styled-components";
import { useDispatch, useSelector } from "react-redux";
import { ownerFileUploadRequest } from "../../redux/uploadDocuments/action";
import CustomLoader from "../../components/CustomLoader";
import { useResponsive } from "../../hooks/useResponsive";
import storePersist, { localConstant } from "../../services/localStorage";
import NavBar from "../../NavBar";
import { enqueueSnackbar } from "notistack";
import SnackbarConfig from "../../utils/snackbarConfig";
import { useTranslation } from "react-i18next";

const UploadDocuments = ({
  enableNav = true,
  isDialog = false,
  resetDialog = () => {},
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isLoading } = useSelector((state) => state.uploadDocReducer);

  const [uploadedInsurance, setUploadedInsurance] = useState(null);
  const [uploadedDL, setUploadedDL] = useState(null);
  const [uploadedLogo, setUploadedLogo] = useState(null);
  const names = [
    t("pages.uploadDocuments.text04"),
    t("pages.uploadDocuments.text05"),
    t("pages.uploadDocuments.text09"),
  ];

  const [value, setValue] = React.useState(names[0]);
  const [inputValue, setInputValue] = React.useState("Drivers License");

  const smDown = useResponsive("down", "sm");

  const handleInsuranceUploadChange = (e) => {
    const uploadedFile = e.target.files[0];
    setUploadedInsurance(uploadedFile);
  };

  const handleDLUploadChange = (e) => {
    const uploadedFile = e.target.files[0];
    setUploadedDL(uploadedFile);
  };

  const handleLogoUploadChange = (e) => {
    const uploadedFile = e.target.files[0];
    setUploadedLogo(uploadedFile);
  };

  const handleInsuranceUploadClick = (e) => {
    e.target.value = null;
  };

  const handleRemoveInsurance = () => {
    setUploadedInsurance(null);
  };

  const handleDLUploadClick = (e) => {
    e.target.value = null;
  };

  const handleRemoveDL = () => {
    setUploadedDL(null);
  };

  const handleLogoUploadClick = (e) => {
    e.target.value = null;
  };

  const handleRemoveLogo = () => {
    setUploadedLogo(null);
  };
  const userId = storePersist.get(localConstant.USER_ID);

  const handleSubmitClick = () => {
    if (!uploadedDL && value === t("pages.uploadDocuments.text04")) {
      enqueueSnackbar(t("pages.uploadDocuments.text07"), {
        variant: "error",
        autoHideDuration: 3000,
        action: SnackbarConfig,
      });
      return;
    }
    if (!uploadedInsurance && value === t("pages.uploadDocuments.text05")) {
      enqueueSnackbar("Please upload required documents!", {
        variant: "error",
        autoHideDuration: 3000,
        action: SnackbarConfig,
      });
      return;
    }
    if (!uploadedLogo && value === t("pages.uploadDocuments.text09")) {
      enqueueSnackbar("Please upload company logo!", {
        variant: "error",
        autoHideDuration: 3000,
        action: SnackbarConfig,
      });
      return;
    }

    let fileToUpload, documentType;
    if (inputValue === t("pages.uploadDocuments.text04")) {
      fileToUpload = uploadedDL;
      documentType = "DRIVLIC";
    } else if (inputValue === t("pages.uploadDocuments.text05")) {
      fileToUpload = uploadedInsurance;
      documentType = "PROOFINS";
    } else if (inputValue === t("pages.uploadDocuments.text09")) {
      fileToUpload = uploadedLogo;
      documentType = "CMPLOGO";
    }

    dispatch(
      ownerFileUploadRequest(fileToUpload, documentType, userId, (data) => {
        if (data?.statuscode === 200) {
          enqueueSnackbar(t("pages.uploadDocuments.text08"), {
            variant: "success",
            autoHideDuration: 3000,
            action: SnackbarConfig,
          });
          setUploadedDL(null);
          setUploadedInsurance(null);
          resetDialog();
          navigate("/documents");
        }
      }),
    );
  };

  const renderDocumentsUploadView = (
    <Stack spacing={2} width={1}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Typography
          variant="customLable"
          color="common.inputCustomLable"
          marginBottom={2}
          alignSelf={"flex-start"}
          marginLeft={1}
        >
          {t("pages.uploadDocuments.text03")}
          {<span style={{ color: "#C50F1F" }}> *</span>}
        </Typography>
        <Autocomplete
          disableClearable // not able to clear the text while selecting the label.
          clearIcon={false}
          fullWidth
          value={value}
          onChange={(event, newValue) => {
            setValue(newValue);
          }}
          inputValue={inputValue}
          onInputChange={(event, newInputValue) => {
            setInputValue(newInputValue);
          }}
          id="controllable-states-demo"
          options={names}
          style={{ height: 40, borderRadius: 0 }}
          renderInput={(params) => (
            <TextField
              {...params}
              label=""
              style={{ borderRadius: 0, borderWidth: 0 }}
              variant="outlined"
              fullWidth
              disabled // making label readonly
            />
          )}
        />

        {inputValue === t("pages.uploadDocuments.text04") && (
          <div
            style={{
              flexDirection: "column",
              marginTop: 40,
              display: "flex",
              width: "100%",
            }}
          >
            <Typography
              variant="customLable"
              color="common.inputCustomLable"
              marginBottom={1}
              marginLeft={1}
            >
              {t("pages.uploadDocuments.text04")}
              {<span style={{ color: "#C50F1F" }}> *</span>}
            </Typography>
            <Button
              variant="outlined"
              fullWidth
              startIcon={<CloudUploadIcon />}
              sx={{
                width: "100%",
                height: 40,
                borderWidth: 1,
                backgroundColor: "#fff",
                color: "#1D5AB9",
                borderColor: "#1D5AB9",
                marginBottom: 1,
                borderRadius: 0,
                ":hover": { backgroundColor: "transparent" },
              }}
              disabled={uploadedDL}
              component="label"
            >
              {t("pages.uploadDocuments.pageHeading")}
              <VisuallyHiddenInput
                type="file"
                onChange={handleDLUploadChange}
                onClick={handleDLUploadClick}
                accept="image/png, image/jpeg, application/pdf"
              />
            </Button>

            {uploadedDL && (
              <div className="uploaded_image uploaded_dl">
                <div className="left_section_uploaded_image">
                  <span className="file_icon_wrapper">
                    <File className="file_icon" />
                  </span>
                  <div style={{ width: "90%" }}>
                    <Typography
                      variant="customLable"
                      color="common.inputCustomLable"
                    >
                      {uploadedDL.name}
                    </Typography>
                  </div>
                </div>
                <button className="cross_icon_btn" onClick={handleRemoveDL}>
                  <CrossBtn className="cross_icon" />
                </button>
              </div>
            )}
          </div>
        )}

        {inputValue === t("pages.uploadDocuments.text05") && (
          <div
            style={{
              flexDirection: "column",
              display: "flex",
              marginTop: 30,
              width: "100%",
            }}
          >
            <Typography
              variant="customLable"
              color="common.inputCustomLable"
              marginBottom={1}
              alignSelf={"flex-start"}
            >
              {t("pages.uploadDocuments.text05")}
              {<span style={{ color: "#C50F1F" }}> *</span>}
            </Typography>
            <Button
              variant="outlined"
              fullWidth
              startIcon={<CloudUploadIcon />}
              sx={{
                width: "100%",
                height: 40,
                borderWidth: 1,
                backgroundColor: "#fff",
                color: "#1D5AB9",
                borderColor: "#1D5AB9",
                borderRadius: 0,
                ":hover": { backgroundColor: "transparent" },
              }}
              disabled={uploadedInsurance}
              component="label"
            >
              {t("pages.uploadDocuments.pageHeading")}
              <VisuallyHiddenInput
                type="file"
                onChange={handleInsuranceUploadChange}
                onClick={handleInsuranceUploadClick}
                accept="image/png, image/jpeg, application/pdf"
              />
            </Button>
            {uploadedInsurance && (
              <div className="uploaded_image">
                <div className="left_section_uploaded_image">
                  <span className="file_icon_wrapper">
                    <File className="file_icon" />
                  </span>
                  <Typography
                    variant="customLable"
                    color="common.inputCustomLable"
                  >
                    {uploadedInsurance.name}
                  </Typography>
                </div>
                <button
                  className="cross_icon_btn"
                  onClick={handleRemoveInsurance}
                >
                  <CrossBtn className="cross_icon" />
                </button>
              </div>
            )}
          </div>
        )}

        {inputValue === t("pages.uploadDocuments.text09") && (
          <div
            style={{
              flexDirection: "column",
              display: "flex",
              marginTop: 30,
              width: "100%",
            }}
          >
            <Typography
              variant="customLable"
              color="common.inputCustomLable"
              marginBottom={1}
              alignSelf={"flex-start"}
            >
              {t("pages.uploadDocuments.text09")}
              {<span style={{ color: "#C50F1F" }}> *</span>}
            </Typography>
            <Button
              variant="outlined"
              fullWidth
              startIcon={<CloudUploadIcon />}
              sx={{
                width: "100%",
                height: 40,
                borderWidth: 1,
                backgroundColor: "#fff",
                color: "#1D5AB9",
                borderColor: "#1D5AB9",
                borderRadius: 0,
                ":hover": { backgroundColor: "transparent" },
              }}
              disabled={uploadedLogo}
              component="label"
            >
              {t("pages.uploadDocuments.pageHeading")}
              <VisuallyHiddenInput
                type="file"
                onChange={handleLogoUploadChange}
                onClick={handleLogoUploadClick}
                accept="image/png, image/jpeg"
              />
            </Button>
            {uploadedLogo && (
              <div className="uploaded_image">
                <div className="left_section_uploaded_image">
                  <span className="file_icon_wrapper">
                    <File className="file_icon" />
                  </span>
                  <Typography
                    variant="customLable"
                    color="common.inputCustomLable"
                  >
                    {uploadedLogo.name}
                  </Typography>
                </div>
                <button className="cross_icon_btn" onClick={handleRemoveLogo}>
                  <CrossBtn className="cross_icon" />
                </button>
              </div>
            )}
          </div>
        )}
      </Box>
    </Stack>
  );

  return (
    <Container
      disableGutters
      maxWidth={false}
      style={{
        position: "relative",
        minHeight: !isDialog && "100vh",
        backgroundColor: "#80BCFF4F",
        width: isDialog ? "100%" : "100vw",
        height: isDialog ? "auto" : "100vh",
      }}
    >
      {enableNav && (
        <NavBar
          title={t("pages.uploadDocuments.pageHeading")}
          enableMenu={false}
        />
      )}
      <Box
        maxWidth="xs"
        sx={{
          flexGrow: 1,
          height: 1,
          minHeight: 1,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Stack
          alignItems="center"
          justifyContent="center"
          sx={{ height: 1, width: 1, padding: 0 }}
        >
          <Card
            sx={{
              p: 3,
              pb: 0,
              width: 1,
              maxWidth: 600,
              height: smDown ? 1 : "auto",
              alignItems: "center",
            }}
            className="form_container"
          >
            {renderDocumentsUploadView}
            <LoadingButton
              fullWidth
              sx={{ mb: 5, mt: 5 }}
              size="large"
              type="submit"
              variant="contained"
              color="inherit"
              onClick={handleSubmitClick}
              disabled={isLoading}
            >
              {t("commonLabels.text01")}
            </LoadingButton>
          </Card>
        </Stack>
      </Box>

      {isLoading && <CustomLoader />}
    </Container>
  );
};

export default UploadDocuments;

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});
